import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import {GenerateDocumentContentMessage, MessageBlockType} from 'notebook/ai-tools/NotebookAIToolsConstants';
import {assertNever} from 'util/Types';

interface AIContentMessagePreviewProps {
  message: GenerateDocumentContentMessage;
}

/**
 * UI showing a response from the LLM after the user requests to write content. This response may
 * be a mix of conversational "discussion" text and notebook content the LLM is proposing.
 */
export default function AIContentMessagePreview({message}: AIContentMessagePreviewProps): JSX.Element {
  return (
    <div>
      {message.messageBlocks.flatMap((messageBlock, i) => {
        if (messageBlock.type === MessageBlockType.DISCUSSION) {
          return [
            <div key={i}>
              {messageBlock.text.split('\n').map((line, j) => (
                <div key={j}>{line}</div>
              ))}
            </div>,
          ];
        } else if (messageBlock.type === MessageBlockType.CONTENT) {
          return [
            <div key={i} className={css(styles.content)}>
              {messageBlock.partialNoteParts.map((partialNotePart, j) => (
                <div key={j}>{partialNotePart.text ?? ''}</div>
              ))}
            </div>,
          ];
        } else if (messageBlock.type === MessageBlockType.THOUGHT) {
          return [];
        } else {
          assertNever(messageBlock);
          return [];
        }
      })}
    </div>
  );
}

const styles = StyleSheet.create({
  content: {
    margin: 10,
  },
});
